<template>
    <div v-if="fetched">
        <div class="card">
            <div class="card-header d-flex justify-content-between">
                <div style="margin-top: 2px;">クレジットカード</div>
                <b-button
                    v-if="card === null"
                    size="sm"
                    variant="yokumiru-orange"
                    @click="openModalStoreCreditCard">
                    クレジットカードを登録
                </b-button>
                <b-button
                    v-else
                    size="sm"
                    variant="yokumiru-gray"
                    @click="openModalDestroyCreditCard">
                    クレジットカードを削除
                </b-button>
            </div>

            <div class="card-body small">
                <template v-if="card !== null">
                    <div class="row">
                        <div class="col-12 col-md-3">カード番号</div>
                        <div class="col-12 col-md-9">{{ `**** **** ${card.last4}` }}</div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-12 col-md-3">カード名義</div>
                        <div class="col-12 col-md-9">{{ card.name }}</div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-12 col-md-3">有効期限</div>
                        <div class="col-12 col-md-9">{{ `${card.exp_year}年${card.exp_month}月` }}</div>
                    </div>
                </template>
                <template v-else-if="card === null && fetched">
                    <div>クレジットカードは未登録です。</div>
                </template>
            </div>
        </div>

        <store-credit-card-modal/>
        <destroy-credit-card-modal/>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'

    export default {
        props: {
            pubkey: {
                type: String,
                required: true,
            },
            user: {
                type: Object,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                card: null,
                fetched: false,
                errors: {},
                isCardStored: false,
            }
        },

        created: function () {
            this.fetchCreditCard()
            bus.$on('credit-card-stored', this.fetchCreditCardByPaymentMethod)
            bus.$on('credit-card-destroyed', this.clearCreditCard)
        },

        beforeDestroy: function () {
            bus.$off('credit-card-stored')
            bus.$off('credit-card-destroyed')
        },

        methods: {
            /**
             * カード取得
             */
            fetchCreditCard: function () {
                axios.get(constants.user.credit_cards.endpoint.base)
                    .then(({data}) => {
                        this.card = data.data
                        this.fetched = true
                    })
            },

            /**
             * 登録完了後のカード再取得
             *
             * @param {string} pm_id
             */
            fetchCreditCardByPaymentMethod: function (pm_id) {
                axios.get(`${constants.user.credit_cards.endpoint.base}/${pm_id}`)
                    .then(({data}) => {
                        this.card = data.data
                        this.isCardStored = true
                    })
            },

            /**
             * カード登録状態を初期化
             */
            clearCreditCard: function () {
                this.card = null
            },

            /**
             * カード登録モーダル表示
             */
            openModalStoreCreditCard: function () {
                bus.$emit('open-modal-store-credit-card', this.pubkey)
            },

            /**
             * カード削除モーダル表示
             */
            openModalDestroyCreditCard: function () {
                bus.$emit('open-modal-destroy-credit-card', this.card)
            },
        },
    }
</script>
